import {useHistory} from 'react-router-dom';

import styled from "styled-components";
import React, {useState} from "react";
import {Spinner} from "@chakra-ui/react";
import Message from '../../components/message';
import MessageList from '../../components/message_list';
import {WhiteMain} from '../../components/main';
import {FixedTopBar} from '../../components/top_bar';
import {useMessages} from "../../api/message";
import {useBottomBar} from "../../app_context";
import useFeedback from "../../utils/use_feedback";
import {useQuery} from "../../utils/router";
import CommentActions from "../../components/comment_actions";
import useAtBottom from "../../utils/use_at_bottom";
import {useStoreComment, useStoreProfile} from "../../store";
import {themecolors} from "../../utils/themecolors";
import MessageToggles from "../../components/message_toggles";
import Comment2 from "../../components/comment2";

const SpinnerContainer = styled.div`
  text-align: center;
  padding: 48px 0;
`;

const Item = styled(({className, message, last}) => {
    const history = useHistory();
    const comment = useStoreComment(message?.comment_id);
    const handleClick = () => {
        if (comment) {
            history.push(`/p/${comment.post_uuid}/x/c/${comment.uuid}/`);
        } else {
            history.push(`/message/${message.conversation_id}`);
        }
    }
    return (
        <div className={className} onClick={handleClick}>
            {comment ?
                <Comment2 comment={comment} contextual />
                :
                <Message showSubject message={message}/>
            }
        </div>
    );
})`
  ${Message} {
    border-bottom: ${({last}) => last ? 0 : 1}px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
  }
`;

const Messages = () => {
    const {theme} = useStoreProfile();
    const {feedbackCh} = useFeedback();
    const {type} = useQuery();
    const [messages, setMessages] = useState(null);
    const { loadNextPage, loading } = useMessages(feedbackCh, setMessages, type || 'all', 1);
    const detector = useAtBottom(loadNextPage);
    useBottomBar();
    return (
        <>
            <FixedTopBar title="Messages" back settings />
            <MessageToggles activeTopic={type} />
            <WhiteMain>
                <MessageList>
                    {loading &&
                    <SpinnerContainer>
                        <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor={theme === "dark" ? themecolors.dark_background_5 : themecolors.light_low_impact_text}
                            color={theme === "dark" ? themecolors.dark_background_2 : themecolors.pure_white}
                            size='lg'
                        />
                    </SpinnerContainer>
                    }
                    {messages?.map((message, index) => (
                        <Item key={message.id} message={message} last={index === messages.length -1} />
                    ))}
                    {detector}
                </MessageList>
            </WhiteMain>
        </>
    );
};

export default Messages;
